// Move Parcely widget into cart summary (Meshkos)
document.addEventListener("DOMContentLoaded", () => {
  const moveParcely = () => {
    const parcelyWidget = document.getElementById("parcelyWidget");
    const summary = document.querySelector(".cart-page__summary");

    if (!parcelyWidget || !summary) return false;

    const checkoutBtn =
      summary.querySelector('button[name="checkout"]') ||
      summary.querySelector('a[href*="/checkout"]');

    if (summary.contains(parcelyWidget)) return true;

    if (checkoutBtn) {
      checkoutBtn.parentElement.insertBefore(parcelyWidget, checkoutBtn);
    } else {
      summary.appendChild(parcelyWidget);
    }
    return true;
  };

  if (moveParcely()) return;

  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    if (moveParcely() || attempts > 25) clearInterval(timer);
  }, 250);
});
